// extracted by mini-css-extract-plugin
export var centerText = "_8e-8";
export var container = "_8e-0";
export var doughnutContainer = "_8e-7";
export var legend = "_8e-a";
export var legendItemColorDisplay = "_8e-b";
export var legendItemLabel = "_8e-d";
export var legendItemValue = "_8e-c";
export var lg = "_8e-5";
export var maxWidth = "_8e-9";
export var md = "_8e-4";
export var responsive = "_8e-6";
export var sm = "_8e-3";
export var xs = "_8e-2";
export var xxs = "_8e-1";